import {useRef} from 'react';
import {useIsPushNotificationEnabled} from '../../../../backend-services/PushNotification/useIsPushNotificationEnabled';
import {DevicePushState} from '../../../useDevicePushState/enums/DevicePushState';
import {useDevicePushState} from '../../../useDevicePushState/useDevicePushState';
import {usePushNotificationToggleShown} from './usePushNotificationToggleShown';

export const useShouldShowPushNotificationTrigger = () => {
  const {devicePushState} = useDevicePushState();
  const localDevicePushState = useRef(devicePushState);

  const {wasShown, ref} = usePushNotificationToggleShown();
  const isPushNotificationEnabled = useIsPushNotificationEnabled();

  if (
    !isPushNotificationEnabled ||
    !localDevicePushState.current ||
    localDevicePushState.current !== DevicePushState.NOT_SENT ||
    wasShown
  ) {
    return {
      shouldShow: false,
      containerRef: ref,
    };
  }

  return {
    shouldShow: true,
    containerRef: ref,
  };
};
